<sd-4-5-1-radio-group
  [(wctSdModel)]="currentlySelectedTimeframe"
  size="sm">
  @for (button of buttons; track $index) {
    <sd-4-5-1-radio-button
      size="md"
      value="{{ button.timeframe }}"
      [attr.disabled]="!activeButtons || activeButtons[button.timeframe] === undefined ? true : null"
      (click)="timeframe$.next(button.timeframe)">
      <span>
        {{ 'fondDetails.selectedTimeframe.' + button.timeframe | transloco }}
      </span>
    </sd-4-5-1-radio-button>
  }
</sd-4-5-1-radio-group>
